var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg5(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 104,
    viewBox: "0 0 58 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_bd_2805_1693)",
    shapeRendering: "geometricPrecision"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.741 52.3h-15V3.82h41.64V18.1h-26.64v18.24c.96-1.8 5.4-7.8 14.04-7.8h.6c9 0 13.2 6.36 13.2 15.96v29.4c0 11.04-5.88 20.28-20.4 20.28h-2.76c-15.36 0-20.64-7.8-20.64-18.72V61.3h15.24v12.6c0 4.32 2.28 6.6 6.24 6.6 3.84 0 6.24-2.28 6.24-6.6V48.82c0-3.84-1.68-6.6-5.76-6.6-4.44 0-6 2.64-6 6.6v3.48z",
    fill: "#000",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.741 52.3h-15V3.82h41.64V18.1h-26.64v18.24c.96-1.8 5.4-7.8 14.04-7.8h.6c9 0 13.2 6.36 13.2 15.96v29.4c0 11.04-5.88 20.28-20.4 20.28h-2.76c-15.36 0-20.64-7.8-20.64-18.72V61.3h15.24v12.6c0 4.32 2.28 6.6 6.24 6.6 3.84 0 6.24-2.28 6.24-6.6V48.82c0-3.84-1.68-6.6-5.76-6.6-4.44 0-6 2.64-6 6.6v3.48z",
    stroke: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_bd_2805_1693",
    x: -4.719,
    y: -4.68,
    width: 61.8,
    height: 108.36,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_2805_1693"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.75 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_backgroundBlur_2805_1693",
    result: "effect2_dropShadow_2805_1693"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect2_dropShadow_2805_1693",
    result: "shape"
  })))));
}
Svg5.displayName = '5';
export default Svg5;